import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { useMemo } from "react";
import { useChainArch } from "../polychain/hooks/useChainArch";
import { useChainId } from "../polychain/hooks/useChainId";

/**
 * Returns the currently connected/active chain based on wallet state
 */
export function useActiveChain() {
  const $ = _c(7);
  const {
    chains
  } = useChains();
  const activeChainId = useChainId();
  const activeChainArch = useChainArch();
  let t0;
  let t1;
  if ($[0] !== activeChainArch || $[1] !== activeChainId || $[2] !== chains) {
    let t2;
    if ($[4] !== activeChainArch || $[5] !== activeChainId) {
      t2 = c => c.networkId === activeChainId && c.arch === activeChainArch;
      $[4] = activeChainArch;
      $[5] = activeChainId;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = chains.find(t2);
    $[0] = activeChainArch;
    $[1] = activeChainId;
    $[2] = chains;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  t0 = t1;
  return t0;
}